import React, { useCallback, useEffect, useRef, useState } from "react";
import Table from "../components/Table";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { convertDateFormat } from "../services/helper";
import { ToastContainer, toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import PartialPayment from "../components/PartialPayment";

export default function Customer({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin
  )?.branch_id;

  const [customer, setCustomer] = useState([]);
  const [customerToDelete, setCustomerToDelete] = useState();
  // const [customerID, setCustomerID] = useState();
  // const [verifyCustomer, setVerifyCustomer] = useState();

  const isLighMode =
    JSON.parse(
      JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || ""
    )?.light_mode === "yes";

  const userRole = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin") || "null")?.admin || "{}"
  )?.role;

  const navigate = useNavigate();

  const returnTable = async (table) => {
    await setCustomerToDelete(table.map((item) => item.original.id));
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [contractData, setContractData] = useState({
    id: "",
    total_value: "",
    total_paid: "",
    legal_fees: "",
    final_installment: "",
  });
  const [paymentMethod, setPaymentMethod] = useState();
  const [payment, setPayment] = useState();
  const [note, setNote] = useState();
  const [discount, setDiscount] = useState();
  const [receiptData, setReceiptData] = useState();
  const [loading, setLoading] = useState(false);
  const [toInvestor, setToInvestor] = useState("no");

  const handlePayment = () => {
    setLoading(true);
    axios
      .put(
        apiKey + "/get-contract-to-update/" + contractData.id,
        {
          payment: payment,
          discount,
          paymentMethod,
          note,
          user_id: contractData.customer_id,
          branch_id: branchId,
          to_investor: toInvestor,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        document.getElementById("closePaymentModalButton")?.click();
        if (res.data.contract && parseInt(res.data.contract[0].status) === 2) {
          navigate(
            `/dashboard/contracts/valid-contract/complete-contract/${res.data.contract[0].id}`
          );
          window.location.reload();
        } else {
          fetchContractInfo(contractData.id, paymentMethod, true, payment, toInvestor);
        }
        fetchCustomer();
        toast.success(res.data.Message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }).finally(() => setLoading(false));
  };

  const fetchContractInfo = (id, paymentMethod, openModal = false, paidAmount = null, toInvestorVal = null) => {
    axios
      .get(`${apiKey}/get-complete-contract/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setReceiptData({
          ...res.data.result[0],
          paymentMethod,
          ...(paidAmount !== null && paidAmount !== undefined ? { amount: paidAmount } : {}),
          ...(toInvestorVal !== null && toInvestorVal !== undefined ? { to_investor: toInvestorVal } : {}),
        });
        if (openModal) {
          document.getElementById("openReceiptModalButton")?.click();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const totalValue = Number(contractData?.total_value || 0);
    const totalPaid = Number(contractData?.total_paid || 0);
    const downPayment = Number(contractData?.down_payment || 0);
    const discountVal = Number(discount || 0);
    const noInst = Number(contractData?.no_of_installments || 1);

    const netRemaining = Math.max(0, totalValue - totalPaid - discountVal);

    if (netRemaining <= 0) {
      setPayment(0);
      return;
    }

    const totalToDistribute = Math.max(0, totalValue - downPayment);
    let baseInstallment = 0;
    let remainder = 0;

    if (noInst > 0 && totalToDistribute > 0) {
      baseInstallment = Math.floor(totalToDistribute / noInst);
      remainder = totalToDistribute - (baseInstallment * noInst);
    } else if (contractData?.final_installment) {
      baseInstallment = Math.floor(Number(contractData.final_installment));
      remainder = totalToDistribute - (baseInstallment * noInst);
    }

    if (baseInstallment <= 0) {
      baseInstallment = Math.floor(contractData?.final_installment || netRemaining);
    }

    const normalInstallment = baseInstallment > 0 ? baseInstallment : Math.floor(netRemaining);
    const lastInstallment = normalInstallment + Math.max(0, remainder);

    if (netRemaining <= lastInstallment || (netRemaining - normalInstallment) < 1) {
      setPayment(Math.round(netRemaining * 100) / 100);
    } else {
      setPayment(normalInstallment);
    }
  }, [contractData, discount]);

  useEffect(() => {
    setDiscount(contractData.discount || 0);
  }, [contractData]);

  const fetchCustomer = useCallback(() => {
    try {
      axios
        .get(apiKey + "/get-customers", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setCustomer(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [branchId, token]);

  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang.Customer_Name || "Customer Name",
      accessorKey: "FullName",
    },
    {
      header: lang.Identity_Number || "Identity Number",
      accessorKey: "ValidNationalID",
    },
    {
      header: lang.Occupation || "Occupation",
      accessorKey: "Occupation",
    },
    {
      header: lang.Salary || "Salary",
      accessorKey: "salary",
    },
    {
      header: lang.Mobile_Number || "Mobile Number",
      accessorKey: "MobilePhoneNo",
    },
    {
      id: "Status",
      header: lang.Status || "Status",
      cell: (row) => {
        const status = row.row.original.contracts[0]?.contract_status;

        return row.row.original.contracts[0]?.deleted_at ? (
          <span className="badge rounded-pill bg-danger">
            {lang.cancelled || "Cancelled"}
          </span>
        ) : parseInt(status) === 1 ? (
          <span className="badge rounded-pill bg-success">
            {lang.active || "Active"}
          </span>
        ) : parseInt(status) === 2 ? (
          <span className="badge rounded-pill bg-primary">
            {lang.completed || "Completed"}
          </span>
        ) : parseInt(status) === 3 ? (
          <span className="badge rounded-pill bg-danger">
            {lang.defaulted || "Defaulted"}
          </span>
        ) : (
          <span className="badge rounded-pill bg-warning">
            {lang.no_contract || "No Contract"}
          </span>
        );
      },
      // 👇 This tells TanStack how to filter
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;

        const contracts = row.original.contracts || [];
        const status = contracts[0]?.contract_status;

        if (filterValue === "cancelled") {
          return contracts[0]?.deleted_at !== null;
        }
        // If user selects "No Contract"
        if (Number(filterValue) === 0) {
          return contracts.length === 0 || status == null;
        }

        return Number(status) === Number(filterValue) && contracts[0]?.deleted_at === null;
      },
      meta: {
        filterOptions: [
          { label: lang.active || "Active", value: 1 },
          { label: lang.completed || "Completed", value: 2 },
          { label: lang.defaulted || "Defaulted", value: 3 },
          { label: lang.no_contract || "No Contract", value: 0 },
          { label: lang["cancelled"] || "Cancelled", value: "cancelled" },
        ],
      },
    },
    {
      header: lang["Start Date"] || "Start Date",
      cell: (row) =>
        row.row.original.contracts[0]?.date_contract &&
        convertDateFormat(row.row.original.contracts[0]?.date_contract),
    },
    {
      header: lang["Due Date"] || "Due Date",
      cell: (row) =>
        row.row.original.contracts[0]?.date_1st_installment &&
        convertDateFormat(row.row.original.contracts[0]?.date_1st_installment),
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("profile/customer/" + row.row.original.customer_id);
                }}
              >
                {lang.Profile || "Profile"}
              </button>
            </li>
            {(userRole === "dealer" || userRole === "super") && (
              <li>
                <button
                  className="dropdown-item mt-0"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(
                      (isLighMode ? "edit-lightmode-customer/" : "edit-customer/") +
                      row.row.original.customer_id
                    );
                  }}
                >
                  {lang["Edit Customer"] || "Edit Customer"}
                </button>
              </li>
            )}
            <li>
              <button
                className="dropdown-item mt-0"
                disabled={
                  !(
                    row.row.original.contracts[0] &&
                    row.row.original.contracts[0].contract_status
                  )
                    ? true
                    : false
                }
                onClick={(e) => {
                  e.preventDefault();
                  navigate("contracts/" + row.row.original.customer_id);
                }}
              >
                {lang.Contracts || "Contracts"}
              </button>
            </li>
            {(() => {
              const runningContracts = (row.row.original.contracts || []).filter(
                (c) => parseInt(c.contract_status) === 1 || parseInt(c.contract_status) === 3
              );

              return (
                <li>
                  <button
                    className="dropdown-item mt-0"
                    disabled={runningContracts.length === 0}
                    onClick={(e) => {
                      e.preventDefault();
                      if (runningContracts.length === 1) {
                        const contract = runningContracts[0];
                        setContractData({
                          id: contract.contract_id,
                          total_value: contract.total_value,
                          total_paid: contract.total_paid || 0,
                          legal_fees: contract.legal_fees || 0,
                          final_installment: contract.final_installment || 0,
                          customer_id: contract.customer_id,
                          discount: contract.discount || 0
                        });
                        const modalBtn = document.createElement("button");
                        modalBtn.setAttribute("data-bs-toggle", "modal");
                        modalBtn.setAttribute("data-bs-target", "#Comodity");
                        modalBtn.style.display = "none";
                        document.body.appendChild(modalBtn);
                        modalBtn.click();
                        document.body.removeChild(modalBtn);
                      } else if (runningContracts.length > 1) {
                        navigate("contracts/" + row.row.original.customer_id);
                      }
                    }}
                  >
                    {lang.add_payment || "Add Payment"}
                  </button>
                </li>
              );
            })()}
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => {
                  let phoneNo = row.row.original.MobilePhoneNo.toString();
                  let waNum = "+966" + phoneNo.slice(1);
                  window.open("https://wa.me/" + waNum, "_blank");
                }}
              >
                {lang.whatsapp || "WhatsApp"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => {
                  const formData = {
                    customer: row.row.original.customer_id,
                  };
                  if (!isLighMode) {
                    sessionStorage.setItem(
                      "formData",
                      JSON.stringify(formData)
                    );
                    navigate("/dashboard/contracts/identification");
                  } else {
                    navigate(
                      `/dashboard/contracts/future/light-contract?${new URLSearchParams(
                        formData
                      ).toString()}`
                    );
                  }
                }}
              >
                {lang.create_contract || "Create Contract"}
              </button>
            </li>
            {row.row.original?.contracts?.length === 0 && (
              <li>
                <button
                  onClick={() => handleDelete(row.row.original.customer_id)}
                  className="dropdown-item mt-0"
                >
                  {lang.Delete_Text || "Delete"}
                </button>
              </li>
            )}
          </ul>
        </div>
      ),
    },
  ];

  const handleDelete = (id) => {
    if (!window.confirm(lang["Are you sure you want to delete this customer?"] || "Are you sure you want to delete this customer?")) return;
    axios
      .delete(`${apiKey}/delete-single-user/customer/${branchId}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        fetchCustomer();
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message || "Some Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    if (branchId) {
      fetchCustomer();
    }
  }, [branchId, fetchCustomer]);

  useEffect(() => {
    if (customerToDelete) {
      try {
        axios
          .put(
            apiKey + "/delete-user/customer",
            {
              idList: customerToDelete,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            fetchCustomer();
          })
          .catch((err) => {
            console.error("error");
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, [customerToDelete, fetchCustomer, token]);

  return (
    <div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Customer_Management || "Customer Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.Customer_Management || "Customer Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Customer_List || "Customer List"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row justify-content-end w-100">
                  <div className="col-md-4 col-lg-3 mt-4">
                    <Link
                      to={
                        !isLighMode ? "add-customer" : "add-lightmode-customer"
                      }
                    >
                      <button type="button" className="btn btn-primary">
                        <img
                          src="img/fi_plus.png"
                          alt=""
                          className="img-fluid"
                        />
                        {lang.Add_New_Customer || "Add New Customer"}
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="row pt-3">
                  <div className="rr col-9">
                    {lang.Customer_List || "Customer List"}
                  </div>
                </div>
                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={customer}
                      columns={columns}
                      returnTable={returnTable}
                      colFilter={[lang.Status || "Status"]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* add payment modal */}
        <div className="modal fade" id="Comodity" tabindex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handlePayment();
                  }}
                >
                  <div className="row mb-2 mt-5 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Total_Value || "Total Value"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={contractData.total_value}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Remaining || "Remaining"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            contractData.total_value - contractData.total_paid
                          }
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.legal_fees || "Legal Fees"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={contractData.legal_fees}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang["Additional Discount"] || "Additional Discount"}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          value={discount}
                          onChange={(e) => setDiscount(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Remaining || "Remaining"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            contractData.total_value -
                            contractData.total_paid -
                            (discount || 0)
                          }
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.payment || "Payment"}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          max={
                            contractData.total_value - contractData.total_paid
                          }
                          value={payment}
                          onChange={(e) => setPayment(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.payment_method || "Payment Method"}
                        </span>
                        <select
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="form-control"
                          name=""
                          id=""
                          required
                        >
                          <option value="" disabled selected></option>
                          <option value="Cash">{lang.cash || "Cash"}</option>
                          <option value="Bank Transfer">
                            {lang.bank_transfer || "Bank Transfer"}
                          </option>
                          <option value="Card">{lang.card || "Card"}</option>
                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8 mb-3">
                      <label className="w-100">
                        <span style={{ fontSize: "14px" }} className="d-block mb-1">
                          {lang.to_investor || "To Investor"}
                        </span>
                        <div className="d-flex align-items-center gap-4 pt-1">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="toInvestorValidCon"
                              id="toInvestorNoValidCon"
                              value="no"
                              checked={toInvestor === "no"}
                              onChange={(e) => setToInvestor(e.target.value)}
                            />
                            <label className="form-check-label" htmlFor="toInvestorNoValidCon" style={{ fontSize: "14px", cursor: "pointer" }}>
                              {lang.no || "No"}
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="toInvestorValidCon"
                              id="toInvestorYesValidCon"
                              value="yes"
                              checked={toInvestor === "yes"}
                              onChange={(e) => setToInvestor(e.target.value)}
                            />
                            <label className="form-check-label" htmlFor="toInvestorYesValidCon" style={{ fontSize: "14px", cursor: "pointer" }}>
                              {lang.yes || "Yes"}
                            </label>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Note || "Note"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <button
                      id="closePaymentModalButton"
                      type="button"
                      className="btn-save"
                      data-bs-dismiss="modal"
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button disabled={loading} type="submit" className="btn-cancel ms-4">
                      {lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <button
          id="openReceiptModalButton"
          style={{ display: "none" }}
          data-bs-toggle="modal"
          data-bs-target="#myModal1"
        ></button>
        {/* Receipts */}
        <div className="modal fade in" id="myModal1" tabindex="-1">
          <div
            className="modal-content modal-dialog"
            style={{
              maxWidth: "80%",
            }}
          >
            <div className="modal-body print position-relative" ref={componentRef}>
              <button
                type="button"
                className="close"
                data-bs-toggle="modal"
                data-bs-target="#myModal1"
              >
                <i className="fa fa-2x">×</i>
              </button>
              <button
                type="button"
                onClick={handlePrint}
                className="btn btn-primary position-absolute top-0 end-0"
                style={{ margin: "1rem 1rem" }}
              >
                {lang.print_reciept || "Print Receipt"}
              </button>
              {receiptData && <PartialPayment contractData={receiptData} lang={lang} />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

